import {
    HIDE_MODAL,
    SHOW_MODAL,
} from '../constants/modal';

const initialState = {
    modalProps: {},
    modalType: '',
};

function modalReducer(state = initialState, action = {}) {
    switch (action.type) {
    case HIDE_MODAL:
        return initialState;
    case SHOW_MODAL:
        return {
            ...state,
            modalProps: action.modalProps,
            modalType: action.modalType,
        };
    default:
        return state;
    }
}

export default modalReducer;
